import React from 'react';

type Props = {
    title: string;
    description?: string;
};

export default function CardTitle({ title, description }: Props) {
    return (
        <div className="ant-card-meta-detail">
            <div className="ant-card-meta-title">{title}</div>
            <div className="ant-card-meta-description">{description}</div>
        </div>
    );
}
